import { render, staticRenderFns } from "./ProjectDetailTabs.vue?vue&type=template&id=3062e8a0&scoped=true"
import script from "./ProjectDetailTabs.vue?vue&type=script&lang=js"
export * from "./ProjectDetailTabs.vue?vue&type=script&lang=js"
import style0 from "./ProjectDetailTabs.vue?vue&type=style&index=0&id=3062e8a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3062e8a0",
  null
  
)

export default component.exports